"use client";
import { Item } from "@rinastyling/common";
import React, { FC, useEffect, useState } from "react";
import { SocketIoService } from "../../services/SocketIoService";
import ItemCard from "../ItemCard";

const PopupStoreItems: FC<{ items: Item[] }> = ({ items }) => {
  const [storeItems, setStoreItems] = useState(items);

  useEffect(() => {
    SocketIoService.instance.connect();

    SocketIoService.instance.on("storeItemStatusChange", (itemDetails) => {
      console.log("storeItemStatusChange", itemDetails);
      setStoreItems((prev) =>
        prev.map((item) => {
          const update = itemDetails.find((d) => d.itemId === item.id);
          return update ? { ...item, status: update.itemStatus } : item;
        })
      );
    });

    return () => {
      SocketIoService.instance.disconnect();
    };
  }, []);
  return storeItems.map((item) => (
    <ItemCard isAdminPage={false} item={item} key={item.id} />
  ));
};

export default PopupStoreItems;
